/* @flow */
import * as React from 'react';
import { removeFilter, addFilter } from 'reducers/tables';
import Heading from 'components/Heading';
import Row from 'components/Row';
import Checkbox from 'components/Checkbox';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Set } from 'immutable';

import ClickEventTrigger from 'components/ClickEventTrigger';

import type { Filter } from 'components/SmartTable';
import type { Filter as FilterType } from 'reducers/tables';

type Props = {
  namespace: string,
  filters: Filter[],

  selectedFilters: Set<string>,
  addFilter: (namespace: string, filter: FilterType) => any,
  removeFilter: (namespace: string, filter: FilterType) => any,
};

class SmartTableFilters extends React.Component<Props> {
  toggleFilter(filterOption: FilterType) {
    const fn = this.props.selectedFilters.get(filterOption.key)
      ? this.props.removeFilter
      : this.props.addFilter;

    fn(this.props.namespace, filterOption);
  }

  renderFilter = (filter: Filter) => {
    const checkboxes = filter.options.map(option => (
      <ClickEventTrigger eventElementName={option.eventElementName}>
        <Checkbox
          name="filter"
          key={option.key}
          label={option.name}
          onChange={() => this.toggleFilter(option)}
          checked={this.props.selectedFilters.has(option.key)}
        />
      </ClickEventTrigger>
    ));

    return (
      <div key={filter.name}>
        <Heading level="2" levelStyle="6">
          {filter.name}
        </Heading>
        {checkboxes}
      </div>
    );
  };
  render() {
    return (
      <div>
        <Row size="xsmall">
          <Heading level="1" levelStyle="4">
            Filter by
          </Heading>
        </Row>
        {this.props.filters.map(this.renderFilter)}
      </div>
    );
  }
}

// $FlowFixMe
function mapStateToProps(state: Object, props: Props) {
  return {
    selectedFilters: state.tables.get(props.namespace).filters,
  };
}

function mapDispatchToProps(dispatch: Function) {
  // $FlowFixMe
  return bindActionCreators({ removeFilter, addFilter }, dispatch);
}

export { SmartTableFilters };
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SmartTableFilters);
